<template>
  <BContainer
    class="mb-4"
  >
    <div class="d-flex justify-content-end mb-3">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <Tasks>
      <template #header-actions="gridTasks">
        <BCol
          cols="12"
          md="9"
        >
          <BFormGroup
            label="Search"
            label-for="filterSearch"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="filterSearch"
              v-model="gridTasks.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
          </BFormGroup>
        </BCol>
        <BCol
          cols="12"
          md="3"
        >
          <BFormGroup
            label="Month"
            label-for="filterMonth"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <flat-pickr
              id="filterMonth"
              v-model="gridTasks.filter.month"
              class="form-control"
              placeholder="--------- ----"
              :config="flatPickerConfig"
            />
          </BFormGroup>
        </BCol>
      </template>
    </Tasks>
  </BContainer>
</template>
<script>
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'

import Tasks from '@/views/fso/tasks/Tasks.vue'

export default {
  name: 'FSOTasksBase',

  components: {
    Tasks
  },

  middleware: ['auth', 'fso'],

  metaInfo: () => ({
    title: 'Tasks'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      }
    }
  }
}
</script>
